module.exports = __webpack_public_path__ + "img/flow_3.1de70753.png";